export default "__VITE_PUBLIC_ASSET__8117dbe0__"